/** @jsxImportSource @emotion/react */

import React from 'react';

interface IProps extends React.SVGProps<SVGSVGElement> {
  width?: number;
  height?: number;
}

function SoccerPitchIcon(props: IProps) {
  const { width, height, ...rest } = props;

  return (
    <svg width={width ?? 16} height={height ?? 16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <g clipPath="url(#clip0_16721_51137)">
        <path
          d="M8.00026 2.68421C6.1782 2.68421 4.3582 2.55489 2.55394 2.29695L0.473941 2H0.131836V15H0.473941L2.55394 14.7031C4.35786 14.4446 6.17792 14.3152 8.00026 14.3158M8.00026 2.68421C9.82231 2.68421 11.6423 2.55489 13.4466 2.29695L15.5266 2H15.8687V15H15.5266L13.4466 14.7031C11.6427 14.4446 9.82259 14.3152 8.00026 14.3158M8.00026 2.68421V6.44737M8.00026 14.3158V10.5526M8.00026 6.44737C8.54465 6.44737 9.06674 6.66363 9.45169 7.04857C9.83663 7.43351 10.0529 7.95561 10.0529 8.5C10.0529 9.04439 9.83663 9.56649 9.45169 9.95143C9.06674 10.3364 8.54465 10.5526 8.00026 10.5526M8.00026 6.44737C7.45586 6.44737 6.93377 6.66363 6.54883 7.04857C6.16388 7.43351 5.94763 7.95561 5.94763 8.5C5.94763 9.04439 6.16388 9.56649 6.54883 9.95143C6.93377 10.3364 7.45586 10.5526 8.00026 10.5526M0.131836 5.42105H0.473941C1.29053 5.42105 2.07367 5.74544 2.65109 6.32286C3.2285 6.90027 3.55289 7.68341 3.55289 8.5C3.55289 9.31659 3.2285 10.0997 2.65109 10.6771C2.07367 11.2546 1.29053 11.5789 0.473941 11.5789H0.131836M15.8687 11.5789H15.5266C14.71 11.5789 13.9268 11.2546 13.3494 10.6771C12.772 10.0997 12.4476 9.31659 12.4476 8.5C12.4476 7.68341 12.772 6.90027 13.3494 6.32286C13.9268 5.74544 14.71 5.42105 15.5266 5.42105H15.8687"
          stroke="white"
          strokeOpacity="0.6"
        />
      </g>
      <defs>
        <clipPath id="clip0_16721_51137">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SoccerPitchIcon;
